import React from "react";

export interface Card {
	title: string;
	description: string;
	bgColor: string;
}

interface DifferentiatorsSectionProps {
	title?: string;
	bgColor?: string;
	rows?: Card[][];
}

export const defaultRows: Card[][] = [
	[
		{
			title: "Deep & Broad Expertise",
			description:
				"We've solved the hardest backend problems and crafted the most polished frontend experiences — often in the same week.",
			bgColor: "bg-purple-50",
		},
	],
];

const getGridColsClass = (cardCount: number): string => {
	switch (cardCount) {
		case 1:
			return "grid-cols-1";
		case 2:
			return "md:grid-cols-2";
		case 3:
			return "md:grid-cols-3";
		case 4:
			return "md:grid-cols-4";
		default:
			return "md:grid-cols-2";
	}
};

const DifferentiatorsSection: React.FC<DifferentiatorsSectionProps> = ({
	title = "",
	bgColor = "bg-black",
	rows = defaultRows,
}) => {
	return (
		<div className={`DifferentiatorsSection ${bgColor} py-[clamp(40px,6.25vw,80px)] px-2 xl:px-0`}>
			<div className="container mx-auto max-w-6xl px-4 md:px-0">
				{title && (
					<h2
						className={`text-3xl md:text-4xl font-bold text-left leading-tight max-w-4xl mb-12 ${
							bgColor === "bg-black" ? "text-white" : "text-black"
						}`}
					>
						{title}
					</h2>
				)}

				<div className="space-y-6">
					{rows.map((row, rowIndex) => (
						<div
							key={rowIndex}
							className={`grid grid-cols-1 ${getGridColsClass(row.length)} gap-6`}
						>
							{row.map((card, cardIndex) => (
								<div
									key={cardIndex}
									className={`${card.bgColor} p-6 rounded-lg shadow-md h-full`}
								>
									<h3 className="text-base font-bold mb-2">{card.title}</h3>
									<p className="text-base leading-relaxed">{card.description}</p>
								</div>
							))}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default DifferentiatorsSection;
